import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex gap-3 justify-content-between align-items-start" }
const _hoisted_2 = { class: "d-flex flex-wrap gap-3 align-items-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle-fill ms-2" }, null, -1)
const _hoisted_4 = { class: "d-flex flex-wrap justify-content-end gap-3 align-items-start" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-filter ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompetitorButtonComponent = _resolveComponent("CompetitorButtonComponent")!
  const _component_DateRangePickerComponent = _resolveComponent("DateRangePickerComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.brands, (competitor, index) => {
        return (_openBlock(), _createBlock(_component_CompetitorButtonComponent, {
          key: index,
          competitor: competitor,
          selected: 
					_ctx.$store.state.filters &&
					_ctx.$store.state.filters.brand_ids &&
					_ctx.$store.state.filters.brand_ids.includes(competitor._id) === true
				,
          class: "text-nowrap",
          onToggle: ($event: any) => (_ctx.toggle(competitor))
        }, null, 8, ["competitor", "selected", "onToggle"]))
      }), 128)),
      (_ctx.$permission.canCreateEntity())
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-neutral btn-sm d-flex align-items-center ps-7 pe-3 text-nowrap text-sm py-3 text-sm font-semibold order-last",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (
					_ctx.$limitation.spaceBrandsLimitReached() || _ctx.$limitation.brandsLimitedAccess()
						? _ctx.showPaymentModal()
						: _ctx.$router.push({
								name: _ctx.$config('RouteConfig', 'BrandCreateRouteName'),
								params: _ctx.$route.params,
						  })
				)),
            type: "button"
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('actions', 'AddCompetitor'))), 1),
            _hoisted_3
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "btn-neutral btn-sm d-flex align-items-center ps-7 pe-3 text-nowrap py-3 text-sm font-semibold",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (
					_ctx.$store.dispatch('set', {
						stateProperty: 'filtersOpened',
						value: !_ctx.$store.state.filtersOpened,
					})
				)),
        type: "button"
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
						_ctx.$text('expressions', 'Button_Toggle_Filters')
					)), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$limitation.datesLimitedAccess()? _ctx.showPaymentModal(): ''))
      }, [
        _createVNode(_component_DateRangePickerComponent)
      ])
    ])
  ]))
}